import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IsGAAdmin, IsSAPAdmin } from "src/_helpers/utils";
import { User } from "src/_models/user";
import { AppService } from "src/_services/app.service";
@Component({
  selector: "mat-user-search",
  templateUrl: "./user-search.component.html",
  styleUrls: ["./user-search.component.scss"],
})
export class UserSeachComponent implements OnInit {
  @Input() OperatorId: any;
  @Output() onUserSelection: EventEmitter<User> = new EventEmitter();
  @Output() onClear: EventEmitter<null> = new EventEmitter();

  searchUserName: string = "all";
  usersList: User[] = [];
  filterUsers: User[] = [];
  selectedUser = null;

  constructor(private appService: AppService) {}

  ngOnInit() {
    // this.getUsersList("");
  }

  getUsersList(query: string) {
    let operatorId = this.OperatorId.value.length === 0 ? "" : this.OperatorId.value
    try {
      if (IsSAPAdmin || IsGAAdmin) {
        this.appService
          .getUsersList(query, operatorId)
          .subscribe((res) => {
            if (res.status === "RS_OK") {
              this.usersList = res.users;
              this.filterUsers = res.users;
            }
          });
      } else {
        this.appService.getUsersList(query).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.usersList = res.users;
            this.filterUsers = res.users;
          }
        });
      }
    } catch (err) {}
  }

  onUserSearchHandler(key: string) {
    this.getUsersList(key);
    this.filterUsers = this.findOpion(key);
  }

  findOpion(value: string): User[] {
    //  const filterValue = value;
    return this.usersList.filter((user) => user.userName.includes(value));
  }

  onChangeUserSelection(event: any) {
    const user = this.filterUsers.filter((user: User) => {
      return user.userId === event;
    });

    if (user) {
      this.onUserSelection.emit(user[0]);
    }
  }

  onCancelSearch() {
    this.selectedUser = null;
    this.onClear.emit(null);
  }
}
